import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.get('/api/auth/me');
      setUser(data.user);
      setTenant(data.tenant);
    } catch (error) {
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    // 학원코드 저장 (재방문 시 자동 리다이렉트용)
    if (data.user?.tenantId) {
      localStorage.setItem('academyCode', data.user.tenantId);
    }
    setUser(data.user);
    return data;
  };

  // 저장된 학원코드 가져오기
  const getSavedAcademyCode = () => {
    return localStorage.getItem('academyCode');
  };

  // 저장된 학원코드 삭제
  const clearSavedAcademyCode = () => {
    localStorage.removeItem('academyCode');
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setTenant(null);
  };

  const value = {
    user,
    tenant,
    loading,
    login,
    logout,
    getSavedAcademyCode,
    clearSavedAcademyCode,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin',
    isTeacher: user?.role === 'teacher',
    isAssistant: user?.role === 'assistant',
    isStaff: ['admin', 'teacher', 'assistant'].includes(user?.role)
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
